import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../constants/constants.service';
import { DataService } from '../utils/data/data.service';
import { Session } from '../session/session.service';

@Injectable()
export class IndicadoresService implements OnInit
{
    private authorization : string =
      "";
    constructor(
      private http: HttpClient,
      private session: Session,
      private dataService: DataService
    ){
      this.authorization += session.idToken;
    }

    ngOnInit(){}
    cantidadAPRsHabilitadas(datos, callback){
      var formData: FormData;
      formData = new FormData();
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/indicadores/cantidadAPRsHabilitadas",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/indicadores/indicadores.service.ts